/**
 * Директива для обработки событий изменения ширины колонок
 */
import {Directive, ElementRef, HostListener, inject, Input} from '@angular/core';
import {ResizeEvent} from 'angular-resizable-element';
import {TableComponent} from '../table.component';
import {TableEventService} from '@app/modules/table/services/table-event.service';

@Directive({
    selector: '[resizeColumn]'
})
export class ResizeColumnDirective {
    /**
     * Индекс колонки, ширину которой изменяют
     */
    @Input() targetColumn: any;

    /**
     * Сервис событий в таблице
     */
    tableEventService: TableEventService = inject(TableEventService);

    /**
     * Конструктор класса
     * @param element - элемент, шириину которогу изменяют (шапка колонки)
     * @param tableComponent - компонент таблицы
     */
    constructor(private element: ElementRef, private tableComponent: TableComponent) {
    }

    /**
     * Обработка события изменения ширины
     * @param $event - ResizeEvent
     */
    @HostListener('resizing', ['$event'])
    resizingEvent($event) {
        this.tableEventService.isResizing = true;
        this.resize($event, false);
    }
    /**
     * Обработка события окончания изменения ширины
     * @param $event - ResizeEvent
     */
    @HostListener('resizeEnd', ['$event'])
    resizingEndEvent($event) {
        this.tableEventService.isResizing = true;
        this.resize($event, true);

        setTimeout(() => this.tableEventService.isResizing = false, 100);
    }

    /**
     * Изменение размера ячейки
     * @param event - ResizeEvent
     * @param isEnd - флаг, изменение окончено
     */
    resize(event: ResizeEvent, isEnd: boolean): void {
        // Выбиаем изменения, который происходят вправо
        if (event.edges.right) {
            const tableElement = this.element.nativeElement?.parentElement?.parentElement;
            // Родителем родителя дожна быть таблица, иначе деректива используется не в том месте
            if (tableElement.nodeName !== 'MAT-TABLE') {
                return;
            }
            let cssValueHeader: number;
            let cssValue: number;
            // Проверяем на минимальную ширину
            if (event.rectangle.width > this.tableComponent.minColumnWidth) {
                // Ширина заголовка
                cssValueHeader = event.rectangle.width;
                // Ширина ячейки
                cssValue = event.rectangle.width;
            }else{
                // Ширина заголовка
                cssValueHeader = this.tableComponent.minColumnWidth;
                // Ширина ячейки
                cssValue = this.tableComponent.minColumnWidth;
            }
            // Ставим ширину найденному элементу
            const columnElements = tableElement.getElementsByClassName('mat-column-' + this.targetColumn.name.replace('.', '-'));
            for (let i = 0; i < columnElements.length; i++) {
                const currentEl = columnElements[i] as HTMLDivElement;
                currentEl.style.width = (i === 0 ? cssValueHeader : cssValue) + 'px';
            }
            this.updateRowWidth(tableElement);
            // По окончанию изменения ширины, надо сохранить настройки таблицы
            if (isEnd){
                this.saveWidth(cssValue);
            }
        }
    }

    /**
     * Обновляем ширину строк по сумме ширины ячеек
     * @param tableElement - Ссылка на таблицу в DOM
     */
    updateRowWidth(tableElement: HTMLElement): void{
        this.tableComponent.dataMatTable.updateStickyColumnStyles();
        // Вычисляем ширину строки с заголовками
        let lengthAll: number = this.tableComponent.settingsTable.displayedColumns.length * 0.45;
        for (const colName of this.tableComponent.settingsTable.displayedColumns){
            const element = tableElement.querySelectorAll('.mat-header-row .mat-column-' +
                colName.replace('.', '-'))[0] as HTMLDivElement;
            lengthAll += (element.style.width === '' ? this.tableComponent.defaultWidth : parseInt(element.style.width, 10));
        }
        // Задаем ширину строк в таблице
        const cssLengthAll: string = (lengthAll - 4) + 'px';
        const headerRows = tableElement.querySelectorAll('.mat-header-row, .mat-row') as NodeListOf<HTMLElement>;
        headerRows.forEach((row) => {
            row.style.width = cssLengthAll;
        });
    }

    /**
     * Сохраняем ширину колонки и текущие настройки таблицы
     * @param width - ширина
     */
    saveWidth(width: number): void{
        // Сохраняем данные в пользовательских колонках
        this.tableComponent.settingsTable.userColumns.forEach(columnItem => {
            if (columnItem.name === this.targetColumn.name) {
                columnItem.width = width;
                columnItem.is_fixed = true;
            }
        });
        // Сохраняем данные в дереве колонок
        this.tableComponent.settingsTable.userTree.select.forEach(node => {
            if (this.tableComponent.getAliasColumn(node) === this.targetColumn.name) {
                node.width = width;
                node.is_fixed = true;
            }
        });
        // Если есть сервис, то сохраняем данные в БД
        if (this.tableComponent.tableService) {
            let settingData = Object.assign({}, this.tableComponent.settingsTable);

            if (this.tableComponent.dynamicFilter) {
                settingData = Object.assign(settingData, this.tableComponent.dynamicFilter);
            }

            if (this.tableComponent.tableModule) {
                settingData.module = this.tableComponent.tableModule;
            }
            this.tableComponent.tableService.saveTableSettings(settingData).toPromise();
        }
    }
}
